export default {
  SET: 'SET',
  SET_DEEP: 'SET_DEEP',
  INIT_STORE: 'INIT_STORE',
  MODAL_SHOW: 'MODAL_SHOW',
  RESET: 'RESET'
}
